import React, { FC, useState } from 'react'

import { LoaderCircle } from 'lucide-react'
import { Button } from '../../ui/button'

interface EditPriceFieldProps {
  label: string
  onSave?: (value: number) => Promise<void>
  onCancel?: () => void
}

export const EditPriceField: FC<EditPriceFieldProps> = ({ label, onSave, onCancel }) => {
  const [loading, setLoading] = useState(false)
  const [value, setValue] = useState<string>('')

  return (
    <div className="flex flex-wrap items-center gap-2">
      <p className="text-xs text-black">{label}</p>
      <input
        type="number"
        placeholder="Enter price"
        className="text-black !text-xs placeholder:!text-xs rounded-md border-black/10 py-1 px-2 w-[134px]"
        value={value}
        onChange={(event) => setValue(event.target.value)}
      />
      {loading && <LoaderCircle className="w-[12px] animate-spin" />}
      {value && (
        <Button
          type="button"
          variant="link"
          className="text-xs p-0 text-black underline hover:no-underline border-r border-solid border-r-black/50 h-auto rounded-none pr-2"
          disabled={loading}
          onClick={async () => {
            if (onSave) {
              setLoading(true)
              await onSave(Number(value))
              setLoading(false)
            }
          }}
        >
          Save
        </Button>
      )}
      <Button
        type="button"
        variant="link"
        className="text-xs p-0 text-black/50 underline hover:no-underline h-auto rounded-none"
        disabled={loading}
        onClick={() => {
          if (onCancel) onCancel()
          setValue('')
        }}
      >
        Cancel
      </Button>
    </div>
  )
}
